let pageData: unknown | undefined;

export function getPageData(): unknown | undefined {
    if (!pageData) {
        const el: HTMLTemplateElement = document.getElementById('page-data') as HTMLTemplateElement;
        const firstNode = el.content.firstChild;
        if (firstNode instanceof Text) {
            pageData = JSON.parse(firstNode.nodeValue);
        } else {
            pageData = {};
        }
    }
    return pageData;
}
